var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.service === 'youtube')?_c('iframe',{attrs:{"height":_vm.data.height,"src":_vm.data.embed,"width":_vm.data.width,"frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }